import UserClient from '@/api/UserClient';

const completedToursKeys = 'acv-complete-search-tours';

export const mutations = {
  setCompletedTours(state, completedTours) {
    state.completedTours = completedTours;
  },
  setCompletedToursLoadedFromApi(state, completedToursLoadedFromApi) {
    state.completedToursLoadedFromApi = completedToursLoadedFromApi;
  },
  setCanShowTours(state, visible) {
    state.canShowTours = visible;
  },
  setCurrentTourPath(state, path) {
    state.currentTourPath = path;
  },
};

export const getters = {
  // returns true if the tourName is included in completedTours
  hasRunTour: (state) => (tourName) => state.completedTours.some((tour) => tour === tourName),
};

export const actions = {
  async getCompletedTours({ rootState, commit, state }) {
    if (state.completedToursLoadedFromApi) {
      return state.completedTours;
    }
    const userClient = new UserClient(rootState.authorization.user);
    const completedToursResponse = await userClient.getKeyValueStoreItem(completedToursKeys);
    let completedTours = [];
    if (completedToursResponse.data.data[completedToursKeys]) {
      // it's stored in the backend like this: "value1,value2,value3"
      completedTours = completedToursResponse.data.data[completedToursKeys].split(',');
    }
    commit('setCompletedTours', completedTours);
    commit('setCompletedToursLoadedFromApi', true);
    return completedTours;
  },
  async setCompletedTours({ rootState, commit, state }, completedTours) {
    const userClient = new UserClient(rootState.authorization.user);
    const uniqueCompletedTours = [
      ...new Set([
        ...state.completedTours,
        ...completedTours,
      ]),
    ];
    await userClient.putKeyValueStoreItem(completedToursKeys, uniqueCompletedTours.join(','));
    commit('setCompletedTours', uniqueCompletedTours);
  },
  // removes ALL tours for user
  async clearCompletedTours({ rootState, commit }) {
    const userClient = new UserClient(rootState.authorization.user);
    const uniqueCompletedTours = [];
    await userClient.putKeyValueStoreItem(completedToursKeys, uniqueCompletedTours.join(','));
    commit('setCompletedTours', uniqueCompletedTours);
  },
  setCanShowTours({ commit }, visible) {
    commit('setCanShowTours', visible);
  },
  setCurrentTourPath({ commit }, path) {
    commit('setCurrentTourPath', path);
  },
};

export const state = {
  completedTours: [],
  completedToursLoadedFromApi: false,
  canShowTours: false,
  currentTourPath: null,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
